/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomOverlayContainer extends OverlayContainer {

    /**
     * Create overlay container and append to ElementRef from directive
     */
    public customCreateContainer(element: HTMLElement): void {
        const container = element.ownerDocument.createElement('div');
        container.classList.add('cdk-overlay-container');
        element.appendChild(container);
        // Keep the currently active container until user interaction selects another host.
        if (!this._containerElement) {
            this._containerElement = container;
        }
    }

    public setContainerElement(element: HTMLElement) {
        this._containerElement = element;
    }
}
